const teamHelpers = {
  userHasTeams: (user, agencyConfiguration) => {
    return user?.approved_team_affiliations?.length > 0 || (agencyConfiguration?.enable_teams && user?.affiliation?.is_admin);
  }
};

export default teamHelpers;
